import React from 'react';
import { CheckIcon, ClockIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
import { CtaButton } from './CtaButton';
const included = ['Los 12 Tomos Maestros', '5 Bonos exclusivos incluidos', 'Para todos los niveles', 'Acceso inmediato', 'Garantía de 7 días'];
const guarantees = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Crédito / Débito'
}];
export function OfferSection() {
  return <section id="comprar" aria-labelledby="oferta" className="scroll-mt-8 border-y border-ink-600 bg-ink-800" data-id="element-139" data-mp="rey2tu9p7tqj">
      <div className="mx-auto max-w-4xl px-5 py-16 sm:py-20" style={{
      paddingTop: "14px",
      paddingBottom: "27px"
    }} data-id="element-140" data-mp="wbokgm15ixe2">
        <div className="text-center" data-id="element-141" data-mp="2t7m9yepgr1bl">
          <p className="inline-flex items-center gap-2 rounded-full border border-court-400/40 bg-court-900/60 px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] text-court-200" data-id="element-142" data-mp="2y3ks3kk77n3k">
            <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-143" data-mp="xx1wnsceca2w" />
            Precio de lanzamiento — por tiempo limitado
          </p>
          
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-slate-400" style={{
          paddingTop: "38px",
          marginTop: "-20px",
          marginBottom: "-20px"
        }} data-id="element-144" data-mp="sy8hzwldid15">
            Valor total del pack completo: <span className="text-slate-200 line-through" data-id="element-145" data-mp="1ll2ykif2ks9c">$92 USD</span>.
            Tu inversión hoy: <span className="font-bold text-ball-400" data-id="element-146" data-mp="1gol0g1e8vs5z">$19 USD</span>.
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-2xl rounded-3xl border border-ball-400/40 bg-ink-900 p-7 shadow-ball sm:p-10" data-id="element-147" data-mp="1ckn2hu0nonei">
          <h3 className="font-display text-2xl uppercase leading-tight text-white sm:text-3xl" data-id="element-148" data-mp="17mbrhfymk6up">
            Padel Pro-Pack Definitivo
          </h3>
          <p className="mt-3 text-sm text-slate-400" data-id="element-149" data-mp="3scawphoac1tm">
            El sistema completo para ordenar tus clases.
          </p>

          <ul className="mt-7 space-y-3 border-y border-ink-600 py-7" data-id="element-150" data-mp="3tv11m8zest3t">
            {included.map(item => <li key={item} className="flex items-center gap-3 text-[15px] text-slate-200" data-id="element-151" data-mp="2mnbbv12m38t">
                <CheckIcon className="h-5 w-5 shrink-0 text-ball-400" strokeWidth={3} aria-hidden="true" data-id="element-152" data-mp="3ku30pzk9p1pg" />
                {item}
              </li>)}
          </ul>

          <div className="mt-7 flex flex-wrap items-end gap-4" data-id="element-153" data-mp="3b3i24c4lfx6j">
            <span className="text-xl font-semibold text-slate-500 line-through" data-id="element-154" data-mp="3b1x4ueqwa04z">$38 USD</span>
            <span className="font-display text-6xl leading-none text-ball-400" data-id="element-155" data-mp="3fvt0hajorawz">$19</span>
            <span className="pb-2 text-sm font-bold uppercase tracking-widest text-slate-400" data-id="element-156" data-mp="316n3lt8blws9">usd</span>
          </div>

          <CtaButton size="lg" className="mt-7 w-full" href={CHECKOUT_URL} data-id="element-157" data-mp="364omad1u3u37">
            👉 Quiero el pack definitivo
          </CtaButton>

          <ul className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-3" data-id="element-158" data-mp="2x3h18wobwpr2">
            {guarantees.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 text-xs font-medium text-slate-400" data-id="element-159" data-mp="2di749367m6zx">
                <Icon className="h-4 w-4 text-court-400" aria-hidden="true" data-id="element-160" data-mp="28koq8ydc51l2" />
                {label}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}